export default {
  baseFontSizeMobile: 14,
  baseFontSize: 16,
  fontFamily: "'Lato', sans-serif;"
}
